import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EmailIcon from "@material-ui/icons/EmailOutlined";

import locale from "@bonliva-crm/locale";
import { ThemeType } from "@theme";

import SecondaryButton from "./buttons/SecondaryButton";
import Body from "./typography/Body";
import { makeStyles } from "@material-ui/core/styles";

type Props = React.ComponentProps<typeof Dialog> & {
  controls?: React.ReactNode;
  header?: React.ReactNode;
  message?: React.ReactNode;
  errorDetails?: React.ReactNode;
};

function sendFeedback(subject, body) {
  const rev = `rev: ${process.env.CRM_APP_REVISION}`;
  window.location.href = `mailto:it@bonliva.se?subject=${subject.toString()} (${rev})&body=${body.toString()}\n\n\n${rev}`;
}

export function ErrorDialog(props: Props) {
  const { controls, header, message: messageProp, errorDetails, ...rest } = props;
  const classes = useStyles(props);

  const message =
    typeof messageProp === "string" ? <Body>{messageProp}</Body> : messageProp;

  return (
    <Dialog open={props.open} fullWidth {...rest}>
      {header && <DialogTitle className={classes.title}>{header}</DialogTitle>}

      <DialogContent className={classes.content}>
        <div>{message}</div>

        {errorDetails && (
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Body>{locale.ClickForDetails}</Body>
            </AccordionSummary>
            <AccordionDetails>
              <Body>{errorDetails}</Body>
            </AccordionDetails>
          </Accordion>
        )}
      </DialogContent>

      <DialogActions style={{ justifyContent: "space-between" }}>
        <SecondaryButton
          leftIcon={<EmailIcon />}
          onClick={() => sendFeedback(header, errorDetails)}
        >
          {locale.SendFeedback}
        </SecondaryButton>

        {controls && <div>{controls}</div>}
      </DialogActions>
    </Dialog>
  );
}

ErrorDialog.defaultProps = {
  header: "Ooups..",
  message: "Something went wrong"
};

const useStyles = makeStyles((theme: ThemeType) => ({
  title: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,

    "& > *": {
      color: "inherit"
    }
  },

  content: {
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing()
  },

  controls: {
    backgroundColor: theme.palette.common.white,
    display: "flex",
    justifyContent: "space-evenly",
    padding: theme.spacing()
  }
}));
